import Page from "../../components/page/Page";
import {useEffect, useMemo, useState} from "react";
import useUserContext from "../../hooks/useUserContext";
import {getShopProducts} from "../../api/getShopProducts";
import Loader from "../../components/loader/Loader";
import "./coupons-products.css";
import Panel from "../../components/panel/Panel";
import {Radio} from "antd";
import CouponProductItem from "./CouponProductItem";
import Search from "antd/es/input/Search";
import EmptyState from "../../components/emptyState/EmptyState";
import {setProductDiscount} from "../../api/setProductDiscount";
import {getProductDiscounts} from "../../api/getProductDiscounts";
import Navigator from "../../components/navigator/Navigator";
import CouponManager from "./CouponManager";

interface CouponsProductsProps {
    isOpen: boolean;
    onClose: () => void;
}

const CouponsProducts = ({ isOpen, onClose }: CouponsProductsProps) => {
    return (
        <Panel isOpen={isOpen} onClose={onClose} width={580}>
            <div className="title">What products are eligible for auto-coupon generation?</div>
            <div className="description">incentivize your clients by creating a special coupon just for their checkout, and send it via Whatsapp message.</div>
            <div className="description">First, you'll need to select what products are eligible for auto-coupon generation. we'll take care of the rest.</div>
            <div className="description"><Navigator to='/docs#coupons' blank>Learn more</Navigator> about auto-generated coupons.</div>
            {/*<div className="product-list-actions-container">*/}
            {/*    <Button type="primary">Select All</Button>*/}
            {/*    <Button type="primary">Unselect All</Button>*/}
            {/*</div>*/}
            <CouponManager isOpen={isOpen} />
        </Panel>
    );
}

export default CouponsProducts;